export default __webpack_public_path__ + "8172b9034573526ff1bc4a9b4dd38580.png";